import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-null-type',
  template: '',
})
export class NullComponent extends FieldType {
}
